var exports = {
  "Nr": "StreamWatchHoverCard.module__card___N01YZU",
  "Br": "StreamWatchHoverCard.module__variantCompact___N01YZU",
  "wy": "StreamWatchHoverCard.module__variantList___N01YZU",
  "VH": "StreamWatchHoverCard.module__preview___N01YZU",
  "sf": "StreamWatchHoverCard.module__previewCompact___N01YZU",
  "$8": "StreamWatchHoverCard.module__previewList___N01YZU",
  "oz": "StreamWatchHoverCard.module__previewImage___N01YZU",
  "nZ": "StreamWatchHoverCard.module__previewFallback___N01YZU",
  "SV": "StreamWatchHoverCard.module__compactButtonWrap___N01YZU",
  "Iq": "StreamWatchHoverCard.module__compactButton___N01YZU",
  "$l": "StreamWatchHoverCard.module__actionRow___N01YZU",
  "uu": "StreamWatchHoverCard.module__actionButtons___N01YZU",
  "jb": "StreamWatchHoverCard.module__listButton___N01YZU",
  "fX": "StreamWatchHoverCard.module__previewClickable___N01YZU",
  "FC": "StreamWatchHoverCard.module__previewHoverOverlay___N01YZU",
  "Mp": "StreamWatchHoverCard.module__previewHoverText___N01YZU",
  "z0": "StreamWatchHoverCard.module__protipRow___N01YZU",
  "cm": "StreamWatchHoverCard.module__protipText___N01YZU",
};

module.exports = exports;
